<!--
 * @Description: 分页
 * @Author: 裴孚
 * @Date: 2023-01-31 18:00:13
 * @LastEditors: 裴孚
 * @LastEditTime: 2023-05-08 17:33:26
-->
<template>
  <div class="paging">
    <el-pagination
      v-model:currentPage="currentPage"
      v-model:page-size="pageSize"
      :page-sizes="[100, 200, 300, 400, 500]"
      :pager-count="pagerCount"
      :background="true"
      :layout="layout"
      :total="totals"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      >
    </el-pagination>
    <el-button class="ml10" link @click="shuaXinClick"><el-icon><RefreshRight /></el-icon></el-button>
  </div>
</template>

<script setup>
import { ref, watch, defineEmits, defineProps } from 'vue'

const props = defineProps({
  pagination: {
    type: Object,
    required: false
  }
})
const emits = defineEmits(['ReturnData'])

const currentPage = ref(1) // 当前页
const pageSize = ref(100) // 每页显示条数
const totals = ref(0) // 总条数
const pagerCount = ref(7) // 最大页码按钮数 数值范围：5 | 7 | 9 | 11 | 13 | 15 | 17 | 19 | 21
const layout = ref('sizes, prev, pager, next, jumper, total') // 组件布局: 每页显示 | 上一页 | 页码 | 下一页 | 跳页 | 总条数

// 每页条数
const handleSizeChange = (val) => {
  emits('ReturnData', currentPage.value, val)
}
// 当前页
const handleCurrentChange = (val) => {
  emits('ReturnData', val, pageSize.value)
}
// 刷新
const shuaXinClick = () => {
  emits('ReturnData')
}

watch(() => props.pagination, () => {
  if (props.pagination) {
    currentPage.value = props.pagination.pageNo || 1 // 当前页
    pageSize.value = props.pagination.pageSize || 100 // 每页显示条数
    totals.value = parseInt(props.pagination.total) || 0 // 总条数
    pagerCount.value = props.pagination.pagerCount || 7 // 最大页码按钮数
    layout.value = props.pagination.layout || 'sizes, prev, pager, next, jumper, total' // 组件布局
  }
}, { deep: true, immediate: true })

</script>
<style lang="less" scoped>
// :deep(.el-select), :deep(.el-select .el-input) {
//   width: 110px !important;
// }
.el-pagination {
  padding-left: 0;
}
:deep(.el-pagination__total) {
  // padding-left: 16px;
}
</style>
